
import {
  Row,
  Col,
  Button,
  Input,
  Icon,
  Select,
  Option,
  Cascader,
  CascaderPanel,
  Dialog,
  Collapse,
  CollapseItem,
  Upload,
  Loading,
  Table,
  TableColumn,
  Pagination,
  Breadcrumb,
  BreadcrumbItem,
  Popover,
  Form,
  FormItem,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  InfiniteScroll,
  Radio,
  RadioGroup,
  RadioButton,
} from "element-ui";

export default {
  install(Vue) {
    [
      Row,
      Col,
      Button,
      Input,
      Icon,
      Loading,
      Breadcrumb,
      BreadcrumbItem,
      Select,
      Option,
      Cascader,
      CascaderPanel,
      Dialog,
      Collapse,
      CollapseItem,
      Upload,
      Table,
      TableColumn,
      Pagination,
      Popover,
      Form,
      FormItem,
      Checkbox,
      CheckboxButton,
      CheckboxGroup,
      InfiniteScroll,
      Radio,
      RadioGroup,
      RadioButton,
    ].forEach((item) => {
      Vue.use(item);
    });
  },
};
